/* Scoped navigation only: product links, quick-add and cart behavior remain unchanged. */
if (!customElements.get('rq-complete-look-slider')) {
  customElements.define('rq-complete-look-slider', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      this.track = this.querySelector('[data-rq-complete-look-track]');
      this.controls = this.querySelector('[data-rq-look-controls]');
      this.previous = this.querySelector('[data-rq-look-previous]');
      this.next = this.querySelector('[data-rq-look-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;

      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.behavior() });
        } else {
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }

    behavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    move(direction) {
      const card = this.track.querySelector('[data-rq-complete-look-card]');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
      this.track.scrollBy({ left: direction * step, behavior: this.behavior() });
    }

    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = maximum <= 1;
      this.previous.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= maximum - 1;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}
